import { createAppAsyncThunk } from '../../store/extensions';
import { CreateConsultationDto, UpdateConsultationDto } from './dtos';
import {
  createConsultationCall,
  fetchConsultationsCall,
  updateConsultationCall,
  deleteConsultationCall,
  fetchConsultationTypesCall,
} from './service';

export const fetchConsultations = createAppAsyncThunk(
  'healthjourney/consultation/getAll',
  (healthjourneyId: string) => {
    return fetchConsultationsCall(healthjourneyId);
  }
);

export const createConsultation = createAppAsyncThunk(
  'healthjourney/consultation/create',
  (newConsultation: CreateConsultationDto) => {
    return createConsultationCall(newConsultation);
  }
);

export const updateConsultation = createAppAsyncThunk(
  'healthjourney/consultation/update',
  (consultation: UpdateConsultationDto) => {
    return updateConsultationCall(consultation);
  }
);

export const deleteConsultation = createAppAsyncThunk(
  'healthjourney/consultation/delete',
  (consultationId: string) => {
    return deleteConsultationCall(consultationId);
  }
);

export const fetchConsultationTypes = createAppAsyncThunk(
  'healthjourney/consultationTypes/getAll',
  () => {
    return fetchConsultationTypesCall();
  }
);
